export default __webpack_public_path__ + "static/media/Tree6.7b81b9ac.png";